var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4072 3.25391L10.4083 3.27539H4.78906C3.99414 3.27539 3.07031 3.37207 2.56543 3.87695C2.06055 4.38184 1.97461 5.29492 1.97461 6.08984V13.1045C1.97461 13.8887 2.06055 14.8018 2.56543 15.3066C3.07031 15.8115 3.99414 15.9082 4.77832 15.9082H11.8037C12.5879 15.9082 13.5117 15.8115 14.0166 15.3066C14.5215 14.8018 14.6074 13.8887 14.6074 13.1045V7.5158C14.6249 7.51844 14.643 7.51855 14.6611 7.51855C15.1855 7.51855 15.6897 7.42126 16.1543 7.23931V12.8682C16.1543 14.2539 16.0469 15.5215 15.1445 16.4346C14.2314 17.3369 12.9424 17.4551 11.5674 17.4551H5.01465C3.62891 17.4551 2.35059 17.3369 1.4375 16.4346C0.53516 15.5215 0.427731 14.2539 0.427731 12.8682V6.31543C0.427731 4.94043 0.53516 3.66211 1.4375 2.74902C2.35059 1.84668 3.63965 1.72852 5.01465 1.72852H10.6988C10.5092 2.20173 10.4072 2.71699 10.4072 3.25391Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6611 6.26172C16.3047 6.26172 17.6689 4.9082 17.6689 3.25391C17.6689 1.61035 16.3047 0.256836 14.6611 0.256836C13.0176 0.256836 11.6641 1.61035 11.6641 3.25391C11.6641 4.9082 13.0176 6.26172 14.6611 6.26172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSenderIcon);
export default __webpack_public_path__ + "static/media/new_sender_icon.a1a604b785db62b75b7656957c4d351d.svg";
export { ForwardRef as ReactComponent };